const scrollSelectorIntoView = (selector) => {
  if (!selector) return;
  const elementToScrollTo = document.querySelector(selector); // <-- Set scroll to element
  if (elementToScrollTo) {
    elementToScrollTo.scrollIntoView({ // <-- If element exists, smooth scroll to it
      behavior: 'smooth',
    });
  }
};

export default scrollSelectorIntoView;
